import { formatAmount } from 'utils/amountUtils';
import { formatDate } from 'utils/date';
import { statusToText } from 'utils/status-to-text';
import { useDebitCreditInfo } from 'views/hooks/useTransactionsDetails';
import { IDepositExtended } from 'views/types/typeTransaction';
import { EngineRun } from '../EnginePath';

const CardDetails: React.FC<{ transaction: IDepositExtended }> = ({
  transaction,
}) => {
  const debitCreditInfo = useDebitCreditInfo(transaction);

  const getCardStatus = (status: string) => {
    return statusToText(status, transaction.type) || status;
  };

  const cardFee = transaction?.fee ? parseFloat(transaction.fee) : 0;

  return (
    <ul className="flex flex-col gap-3">
      <li>
        Type:{' '}
        <span className="font-semibold ml-3 capitalize">
          {transaction?.type?.replaceAll('-', ' ') || 'Card Transaction'}
        </span>
      </li>

      <li>
        Debit/Credit:{' '}
        <span className="font-semibold ml-3">{debitCreditInfo.type}</span>
      </li>

      <li>
        Currency:{' '}
        <span className="font-semibold ml-3">
          {transaction?.currencyIn?.symbol || 'USDT'}
        </span>
      </li>

      <li>
        Amount:{' '}
        <span className="font-semibold ml-3">
          {debitCreditInfo.amount} {transaction?.currencyIn?.symbol || 'USDT'}
        </span>
      </li>

      <li className="flex flex-col">
        <div className="text-sm text-gray-600 dark:text-gray-400 font-medium mb-1">
          Fee Breakdown:
        </div>
        <div className="text-sm ml-2">
          Card Fee:{' '}
          <span className="font-medium">
            {formatAmount(cardFee)} {transaction?.currencyIn?.symbol || 'USDT'}
          </span>
        </div>
      </li>

      <li>
        Card Number:{' '}
        <span className="font-semibold ml-3">
          {transaction?.card?.mask || '****-****-****-****'}
        </span>
      </li>

      <li>
        Client ID:{' '}
        <span className="font-semibold ml-3">
          {transaction?.user?.coins_fly_id || '---'}
        </span>
      </li>

      <li>
        Date:{' '}
        <span className="font-semibold ml-3">
          {transaction?.createdAt
            ? formatDate(transaction.createdAt, 'DD.MM.YYYY HH:mm')
            : '---'}
        </span>
      </li>

      {transaction?.completedOrFailedAt && (
        <li>
          Status Changed at:{' '}
          <span className="font-semibold ml-3">
            {formatDate(transaction.completedOrFailedAt, 'DD.MM.YYYY HH:mm')}
          </span>
        </li>
      )}

      <li>
        Transaction status:{' '}
        <span className="font-semibold ml-3 capitalize">
          {getCardStatus(transaction?.status?.toLowerCase?.())}
        </span>
        {['failed'].includes(transaction?.status?.toLowerCase?.()) &&
          transaction?.reasonOfFailure && (
            <div className="mt-2">
              Reason:{' '}
              <span className="font-semibold">
                {transaction.reasonOfFailure}
              </span>
            </div>
          )}
      </li>

      <li>
        Order: <span className="font-semibold ml-3">{transaction?.id}</span>
      </li>

      {transaction.engineRun && (
        <>
          <li>
            Engine Run: <EngineRun engineRun={transaction.engineRun} />
          </li>
          <li>
            Engine Run Status:{' '}
            <span className="font-semibold ml-3">
              {transaction.engineRun.status}
            </span>
          </li>
        </>
      )}
    </ul>
  );
};
export default CardDetails;
